export function shouldShowViewOnlyAccessNotReady(params: {
  isReadOnly: boolean
  onboardingCompletedAt: string | Date | null | undefined
}): boolean {
  return params.isReadOnly && params.onboardingCompletedAt == null
}

export type SettingsFullAccessRouteState = 'loading' | 'redirect' | 'allow'

export function resolveSettingsFullAccessRoute(params: {
  isFetched: boolean
  isReadOnly: boolean | undefined
}): SettingsFullAccessRouteState {
  if (!params.isFetched) {
    return 'loading'
  }

  if (params.isReadOnly === true) {
    return 'redirect'
  }

  return 'allow'
}

export function getPackagingDocumentPanelPermissions(canWriteOrgData: boolean) {
  return {
    canUpload: canWriteOrgData,
    canDelete: canWriteOrgData,
  } as const
}
